module.exports = __webpack_public_path__ + "img/direction_right.1bac69e5.jpg";